/*
  SingRank - EV charging time calculator for ABLINK's EV listing (v2.2, 2026-10-07: single-column layout; on desktop sits under the photo).
  Brief: Garrick (ABLINK), 7 Oct 2026: "add a charging time calculator on our EV listing".
  Reference look: inchcalculator.com EV charging time calculator (battery kWh, charger kW,
  current %, target % -> time). Ours pre-fills the vehicle and caps at the vehicle's own limit.

  Shows under the "EV Charger" box in BOTH the quick-view popup (#abl-m-ev-*) and the
  full detail view (#abld-ev-*) on /pages/new-commercial-vehicles. Reads the vehicle
  from the same /cars API the page already uses. Does not change the page's own code,
  prices, loan maths or enquiry flow. Renders nothing for non-electric vehicles.
  No backend: everything runs in the visitor's browser.

  Maths: hours = battery kWh x (target% - start%) / 100 / (effective kW x efficiency)
    effective kW = the LOWER of the charger's power and the vehicle's own max AC or DC rate.
    Vehicle rate: /cars API field if present (names below), else VEHICLE_LIMITS, else the
    charger's full power, labelled "fastest possible".
  Rollback: remove the script block in snippets/meta-tags.liquid. Added 2026-10-07 by SingRank.
*/
(function () {
  'use strict';
  if (window.__srEvCalc) return; window.__srEvCalc = true;

  var API = 'https://wowo04okc8cogsc0sc4okco8.34.21.196.238.sslip.io/cars';
  var EFF_AC = 0.9, EFF_DC = 0.92;

  /* Vehicle's own max charging power (kW), keyed by make_model as the /cars API spells it.
     Source: published specs researched 2026-10-07 (research/ABLINK-EV-CHARGING-RATES-to-confirm.csv);
     where sources disagree the LOWER value is used. FORLAND S1 AC 11 kW = stated by ABLINK.
     null = not found yet. */
  var VEHICLE_LIMITS = {
    "SRM T3EV (G-PLATE)": { ac: 11, dc: 55 },
    "SRM T3EV+ (Y-PLATE)": { ac: 11, dc: 55 },
    "FORLAND S1": { ac: 11, dc: null },
    "BYD T35 (Y-PLATE)": { ac: null, dc: 71 },
    "FOTON EMILER": { ac: null, dc: null },
    "HIGER H5F": { ac: null, dc: null },
    "SANY FR601": { ac: null, dc: null },
    "QINGLING EQ2": { ac: null, dc: 120 },
    "MAXUS E DELIVER 5": { ac: 11, dc: 70 },
    "MAXUS E DELIVER 7": { ac: 11, dc: 90 },
    "FOTON IBLUE V6": { ac: null, dc: null },
    "FARIZON SUPERVAN 5M 83KW": { ac: 11, dc: 140 },
    "FARIZON V7E": { ac: 11, dc: 90 },
    "MERCEDES E-CITAN": { ac: 11, dc: 80 },
    "MERCEDES E-VITO": { ac: 11, dc: 80 },
    "CITROEN E-BERLINGO": { ac: 7.4, dc: 100 },
    "CITROEN E-DISPATCH": { ac: 7.4, dc: 100 },
    "OPEL COMBO-E": { ac: 11, dc: 100 },
    "OPEL VIVARO-E": { ac: 11, dc: 100 },
    "BYD ET3": { ac: 6.6, dc: 50 },
    "VOLKSWAGEN ID BUZZ": { ac: 11, dc: 185 },
    "KGM MUSSO 2WD D-CAB": { ac: 10.5, dc: 108 },
    "RIDDARA 4WD ECON": { ac: 6.6, dc: 110 }
  };
  var API_AC_FIELDS = ['max_ac_kw', 'ac_charging_rate', 'charging_rate_ac', 'vehicle_ac_kw', 'charging_rate'];
  var API_DC_FIELDS = ['max_dc_kw', 'dc_charging_rate', 'charging_rate_dc', 'vehicle_dc_kw'];

  var CARS = null, CARS_P = null;
  function loadCars() {
    if (CARS) return Promise.resolve(CARS);
    if (CARS_P) return CARS_P;
    CARS_P = fetch(API, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var list = Array.isArray(j) ? j : (j.data || j.cars || []);
        CARS = {}; list.forEach(function (c) { if (c && c.make_model) CARS[norm(c.make_model)] = c; });
        return CARS;
      })
      .catch(function () { CARS_P = null; return {}; });
    return CARS_P;
  }
  function norm(s) { return String(s || '').trim().toUpperCase().replace(/\s+/g, ' '); }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, '')); return isFinite(n) && n > 0 ? n : null; }
  function firstNum(o, keys) { for (var i = 0; i < keys.length; i++) { var n = num(o && o[keys[i]]); if (n) return n; } return null; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function r1(n) { return Math.round(n * 10) / 10; }

  function limitsFor(v) {
    var k = VEHICLE_LIMITS[norm(v.make_model)] || {};
    return { ac: firstNum(v, API_AC_FIELDS) || num(k.ac), dc: firstNum(v, API_DC_FIELDS) || num(k.dc) };
  }
  function fmtTime(h) {
    if (!isFinite(h) || h <= 0) return '-';
    var m = Math.round(h * 60);
    if (m < 60) return m + ' min';
    var hh = Math.floor(m / 60), mm = m % 60;
    return hh + ' hr' + (mm ? ' ' + mm + ' min' : '');
  }
  function readyBy(h) {
    var d = new Date(Date.now() + h * 3600000);
    var now = new Date();
    var t = d.toLocaleTimeString('en-SG', { hour: 'numeric', minute: '2-digit' });
    var days = Math.round((new Date(d.toDateString()) - new Date(now.toDateString())) / 86400000);
    return t + (days === 1 ? ' tomorrow' : days > 1 ? ' in ' + days + ' days' : ' today');
  }
  function chargerCalc(c, lim, kwh, s, t) {
    var type = /DC/i.test(c.type || c.name) ? 'DC' : 'AC';
    var ck = num(c.power_kw) || num(c.name) || 0;
    var vk = type === 'DC' ? lim.dc : lim.ac;
    var eff = vk ? Math.min(ck, vk) : ck;
    var energy = kwh * Math.max(0, t - s) / 100;
    var hrs = eff ? energy / (eff * (type === 'DC' ? EFF_DC : EFF_AC)) : NaN;
    return { c: c, type: type, ck: ck, vk: vk, eff: eff, energy: energy, grid: energy / (type === 'DC' ? EFF_DC : EFF_AC), hrs: hrs, capped: !!(vk && vk < ck), unknown: !vk };
  }

  var BOLT = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M13 2 4 14h6l-1 8 9-12h-6z"/></svg>';
  var CSS = '' +
    '.sr-evc{--o:#F58220;--od:#BA540B;--n:#12293D;margin-top:16px;border-radius:18px;overflow:hidden;border:1px solid #e2e8f0;background:#fff;box-shadow:0 8px 24px rgba(18,41,61,.08);font-family:inherit;color:#0f172a}' +
    '.sr-evc *{box-sizing:border-box}' +
    '.sr-evc .sr-hd{background:linear-gradient(135deg,#12293D 0%,#1d3d58 100%);color:#fff;padding:14px 16px;display:flex;align-items:center;gap:10px}' +
    '.sr-evc .sr-ic{width:34px;height:34px;border-radius:10px;background:var(--o);display:flex;align-items:center;justify-content:center;color:#fff;flex-shrink:0;box-shadow:0 0 0 4px rgba(245,130,32,.25)}' +
    '.sr-evc .sr-hd b{display:block;font-size:13px;font-weight:800;letter-spacing:.06em;text-transform:uppercase}' +
    '.sr-evc .sr-hd span{display:block;font-size:12px;color:#cbd5e1;font-weight:500;margin-top:1px}' +
    '.sr-evc .sr-bd{padding:16px}' +
    '.sr-evc .sr-lbl{font-size:10px;font-weight:800;color:#64748b;text-transform:uppercase;letter-spacing:.1em;margin:0 0 8px}' +
    '.sr-evc .sr-chips{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:16px}' +
    '.sr-evc .sr-chip{border:1.5px solid #e2e8f0;background:#fff;border-radius:999px;padding:7px 12px;font-size:12px;font-weight:700;color:#334155;cursor:pointer;display:inline-flex;align-items:center;gap:5px;transition:all .15s;font-family:inherit}' +
    '.sr-evc .sr-chip:hover{border-color:var(--o);color:var(--od)}' +
    '.sr-evc .sr-chip.on{background:var(--o);border-color:var(--o);color:#fff;box-shadow:0 4px 12px rgba(245,130,32,.35)}' +
    '.sr-evc .sr-chip i{font-style:normal;font-size:9px;font-weight:800;padding:1px 5px;border-radius:5px;background:#eef2f7;color:#475569}' +
    '.sr-evc .sr-chip.on i{background:rgba(255,255,255,.25);color:#fff}' +
    '.sr-evc .sr-batt{position:relative;height:46px;border:2.5px solid #12293D;border-radius:10px;padding:3px;margin:4px 10px 6px 0;background:#f8fafc}' +
    '.sr-evc .sr-batt:after{content:"";position:absolute;right:-9px;top:13px;width:6px;height:15px;background:#12293D;border-radius:0 3px 3px 0}' +
    '.sr-evc .sr-fill{position:absolute;top:3px;bottom:3px;left:3px;border-radius:6px;background:#cbd5e1}' +
    '.sr-evc .sr-add{position:absolute;top:3px;bottom:3px;border-radius:6px;background:repeating-linear-gradient(-45deg,#F58220 0 10px,#ff9a3d 10px 20px);background-size:28px 28px;animation:srflow 1s linear infinite;transition:left .2s,width .2s}' +
    '@keyframes srflow{to{background-position:28px 0}}' +
    '.sr-evc .sr-pct{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:#0f172a;text-shadow:0 0 6px #fff,0 0 6px #fff;pointer-events:none}' +
    '.sr-evc .sr-sl{display:flex;flex-direction:column;gap:10px;margin:8px 0 16px}' +
    '.sr-evc .sr-sl label{font-size:11px;font-weight:700;color:#475569;display:flex;flex-direction:column;gap:4px}' +
    '.sr-evc .sr-sl label b{font-size:16px;color:#0f172a}' +
    '.sr-evc input[type=range]{width:100%;accent-color:var(--o);cursor:pointer}' +
    '.sr-evc .sr-res{display:flex;flex-direction:column;gap:10px;background:linear-gradient(135deg,#fff7ef,#ffeedd);border:1px solid #fed7aa;border-radius:14px;padding:14px;margin-bottom:16px}' +
    '.sr-evc .sr-big{display:block}' +
    '.sr-evc .sr-big small{display:block;font-size:10px;font-weight:800;color:var(--od);text-transform:uppercase;letter-spacing:.1em}' +
    '.sr-evc .sr-big strong{display:block;font-size:34px;line-height:1.1;font-weight:900;color:#12293D;letter-spacing:-.02em;margin:2px 0}' +
    '.sr-evc .sr-big em{font-style:normal;font-size:12px;color:#475569;font-weight:600}' +
    '.sr-evc .sr-stats{display:flex;flex-direction:column;gap:6px}' +
    '.sr-evc .sr-st{display:flex!important;justify-content:space-between;align-items:center;background:#fff;border-radius:10px;padding:8px 10px;border:1px solid #fde4c8}' +
    '.sr-evc .sr-st small{display:block;font-size:9px;font-weight:800;color:#64748b;text-transform:uppercase;letter-spacing:.08em}' +
    '.sr-evc .sr-st b{display:block;font-size:14px;font-weight:800;color:#0f172a}' +
    '.sr-evc .sr-cap{display:inline-block;margin-top:6px;font-size:11px;font-weight:700;color:#b45309;background:#fff;border:1px solid #fed7aa;border-radius:6px;padding:2px 7px}' +
    '.sr-evc .sr-cmp{display:flex;flex-direction:column;gap:7px;margin-bottom:14px}' +
    '.sr-evc .sr-row{display:grid;grid-template-columns:78px 1fr 92px;align-items:center;gap:8px;font-size:12px;cursor:pointer}' +
    '.sr-evc .sr-row span{font-weight:700;color:#334155}' +
    '.sr-evc .sr-trk{height:10px;background:#eef2f7;border-radius:99px;overflow:hidden}' +
    '.sr-evc .sr-bar{height:100%;border-radius:99px;background:#94a3b8;transition:width .25s}' +
    '.sr-evc .sr-row.on .sr-bar{background:linear-gradient(90deg,#F58220,#ffb066)}' +
    '.sr-evc .sr-row.on span,.sr-evc .sr-row.on b{color:var(--od)}' +
    '.sr-evc .sr-row b{text-align:right;font-weight:800;color:#0f172a;white-space:nowrap}' +
    '.sr-evc .sr-cost{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:12px;color:#475569;font-weight:600;margin-bottom:12px}' +
    '.sr-evc .sr-cost input{width:80px;border:1.5px solid #e2e8f0;border-radius:8px;padding:6px 8px;font-size:13px;font-weight:700;font-family:inherit}' +
    '.sr-evc .sr-cost input:focus{outline:none;border-color:var(--o)}' +
    '.sr-evc .sr-note{font-size:11px;color:#64748b;margin:0;line-height:1.5;font-weight:500}' +
    '.sr-evc .sr-fill,.sr-evc .sr-add,.sr-evc .sr-bar,.sr-evc .sr-trk{display:block!important}' +
    '.sr-evc.sr-in-left{margin-top:20px}' +
    '.sr-evc.sr-at-bottom{margin:28px 0 0;width:100%;max-width:none;box-shadow:none;border:1px solid #e2e8f0}' +
    '.sr-evc .sr-hd{cursor:pointer;list-style:none}.sr-evc .sr-hd::-webkit-details-marker{display:none}.sr-evc .sr-toggle{margin-left:auto;font-size:22px!important;color:#f58220!important;flex-shrink:0}.sr-evc details[open] .sr-toggle{font-size:0!important}.sr-evc details[open] .sr-toggle:after{content:"−";font-size:22px}.sr-evc .sr-add{background:#f58220!important;animation:none!important}' +
    '@media (max-width:480px){.sr-evc .sr-big strong{font-size:28px}.sr-evc .sr-row{grid-template-columns:64px 1fr 80px}}' +
    '@media (prefers-reduced-motion:reduce){.sr-evc .sr-add{animation:none}}';
  function addCss() {
    if (document.getElementById('sr-evc-css')) return;
    var st = document.createElement('style'); st.id = 'sr-evc-css'; st.textContent = CSS; document.head.appendChild(st);
  }


  /* Individual vehicle: keep charging duration below the complete vehicle details. */
  function place(box, grid) {
    var card = grid.closest('.abld-card') || grid;
    if (box.previousElementSibling !== card) card.after(box);
    box.classList.remove('sr-in-left', 'sr-at-bottom');
    box.classList.add('sr-after-charger');
  }
  function placeAll() {
    document.querySelectorAll('.sr-evc[data-grid]').forEach(function (box) {
      var grid = document.getElementById(box.dataset.grid); if (grid) place(box, grid);
    });
  }

  function mount(grid, nameEl) {
    var name = nameEl ? nameEl.textContent : '';
    if (!name) return;
    loadCars().then(function (cars) {
      var v = cars[norm(name)];
      var box = document.querySelector('.sr-evc[data-grid="' + grid.id + '"]');
      if (!v || !/ELECTRIC|\bEV\b/i.test(v.fuel_type || '') || !num(v.capacity) || !(v.ev_chargers || []).length) {
        if (box) box.remove(); return;
      }
      if (!box) {
        box = document.createElement('div'); box.className = 'sr-evc';
        box.dataset.start = '20'; box.dataset.target = '80'; box.dataset.grid = grid.id;
      }
      place(box, grid);
      if (box.dataset.vehicle !== v.make_model) { box.dataset.pick = ''; box.dataset.open = '1'; }
      box.dataset.vehicle = v.make_model;
      var sel = grid.querySelector('.abl-att-card.active');
      if (sel) box.dataset.pick = sel.dataset.name;
      draw(box, v);
    });
  }

  function draw(box, v) {
    var kwh = num(v.capacity), lim = limitsFor(v);
    var s = +box.dataset.start, t = +box.dataset.target;
    var list = (v.ev_chargers || []).filter(function (c) { return c && c.name; });
    var calcs = list.map(function (c) { return chargerCalc(c, lim, kwh, s, t); });
    var pick = box.dataset.pick && calcs.filter(function (x) { return x.c.name === box.dataset.pick; })[0];
    if (!pick) { pick = calcs.filter(function (x) { return x.type === 'AC'; })[0] || calcs[0]; box.dataset.pick = pick.c.name; }
    var maxH = Math.max.apply(null, calcs.map(function (x) { return isFinite(x.hrs) ? x.hrs : 0; })) || 1;
    var anyUnknown = calcs.some(function (x) { return x.unknown; });
    var price = num(box.dataset.price);

    var chips = calcs.map(function (x) {
      return '<button type="button" class="sr-chip' + (x === pick ? ' on' : '') + '" data-n="' + esc(x.c.name) + '"><i>' + x.type + '</i>' + esc(r1(x.ck)) + ' kW</button>';
    }).join('');
    var rows = calcs.map(function (x) {
      var w = isFinite(x.hrs) ? Math.max(4, x.hrs / maxH * 100) : 0;
      return '<div class="sr-row' + (x === pick ? ' on' : '') + '" data-n="' + esc(x.c.name) + '" role="button" tabindex="0"><span>' + esc(x.c.name) + '</span><div class="sr-trk"><div class="sr-bar" style="width:' + w + '%"></div></div><b>' + fmtTime(x.hrs) + (x.unknown ? '*' : '') + '</b></div>';
    }).join('');

    box.innerHTML =
      '<details class="sr-disclosure"' + (box.dataset.open === '1' ? ' open' : '') + '><summary class="sr-hd"><div class="sr-ic">' + BOLT + '</div><div><b>Charging time calculator</b><span>' + esc(v.make_model) + ' &middot; ' + esc(r1(kwh)) + ' kWh battery' +
        (lim.ac ? ' &middot; AC up to ' + r1(lim.ac) + ' kW' : '') + (lim.dc ? ' &middot; DC up to ' + r1(lim.dc) + ' kW' : '') + '</span></div><span class="sr-toggle" aria-hidden="true">+</span></summary>' +
      '<div class="sr-bd">' +
        '<p class="sr-lbl">1. Pick a charger</p><div class="sr-chips">' + chips + '</div>' +
        '<p class="sr-lbl">2. Set the charge</p>' +
        '<div class="sr-batt" aria-hidden="true"><div class="sr-fill" style="width:calc(' + s + '% - 6px)"></div><div class="sr-add" style="left:calc(' + s + '% + 3px);width:calc(' + (t - s) + '% - 6px)"></div><div class="sr-pct">' + s + '% &rarr; ' + t + '%</div></div>' +
        '<div class="sr-sl">' +
          '<label>Battery now <b>' + s + '%</b><input type="range" min="0" max="95" step="5" value="' + s + '" data-k="start" aria-label="Battery now, percent"></label>' +
          '<label>Charge to <b>' + t + '%</b><input type="range" min="10" max="100" step="5" value="' + t + '" data-k="target" aria-label="Charge to, percent"></label>' +
        '</div>' +
        '<div class="sr-res" aria-live="polite">' +
          '<div class="sr-big"><small>Estimated charging time</small><strong>' + fmtTime(pick.hrs) + (pick.unknown ? '*' : '') + '</strong>' +
            '<em>Plug in now &rarr; ready about ' + (isFinite(pick.hrs) ? readyBy(pick.hrs) : '-') + '</em>' +
            (pick.capped ? '<br><span class="sr-cap">This van takes max ' + r1(pick.vk) + ' kW, so the ' + r1(pick.ck) + ' kW charger runs at ' + r1(pick.vk) + ' kW</span>' : '') +
          '</div>' +
          '<div class="sr-stats">' +
            '<div class="sr-st"><small>Energy added</small><b>' + r1(pick.energy) + ' kWh</b></div>' +
            '<div class="sr-st"><small>Charging at</small><b>' + r1(pick.eff) + ' kW ' + pick.type + '</b></div>' +
            '<div class="sr-st"><small>From the grid</small><b>' + r1(pick.grid) + ' kWh</b></div>' +
            '<div class="sr-st"><small>Est. cost</small><b>' + (price ? '$' + (pick.grid * price).toFixed(2) : '&mdash;') + '</b></div>' +
          '</div>' +
        '</div>' +
        '<p class="sr-lbl">All chargers compared</p><div class="sr-cmp">' + rows + '</div>' +
        '<div class="sr-cost"><span>Your electricity price</span>$<input type="number" min="0" step="0.01" inputmode="decimal" placeholder="0.00" value="' + (price || '') + '" aria-label="Electricity price per kWh in dollars"> per kWh <span style="color:#94a3b8">(optional, for the cost estimate)</span></div>' +
        '<p class="sr-note">Estimate only. Real time depends on battery temperature, charger condition and the vehicle. DC charging slows down above about 80%. Vehicle charging limits are from published specifications.' +
          (anyUnknown ? ' * Fastest possible: this vehicle\'s own maximum rate for that charger type is still being confirmed, so the real time may be longer.' : '') + '</p>' +
      '</div></details>';
    box.querySelector('.sr-disclosure').addEventListener('toggle', function () { box.dataset.open = this.open ? '1' : '0'; });

    box.querySelectorAll('input[type=range]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var k = inp.dataset.k, val = +inp.value;
        if (k === 'start') box.dataset.start = String(Math.min(val, +box.dataset.target - 5));
        else box.dataset.target = String(Math.max(val, +box.dataset.start + 5));
        draw(box, v);
        var again = box.querySelector('input[data-k="' + k + '"]'); if (again) again.focus();
      });
    });
    box.querySelectorAll('.sr-chip,.sr-row').forEach(function (el) {
      function go() { box.dataset.pick = el.dataset.n; draw(box, v); }
      el.addEventListener('click', go);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
    var pr = box.querySelector('.sr-cost input');
    if (pr) pr.addEventListener('change', function () { box.dataset.price = pr.value; draw(box, v); });
  }

  function scan() {
    document.querySelectorAll('[id^="abld-ev-"].abl-ev-grid').forEach(function (grid) {
      if (/-section-|-card-/.test(grid.id)) return;
      var sid = grid.id.replace(/^abld-ev-|^abl-m-ev-/, '');
      var nameEl = document.getElementById((grid.id.indexOf('abld-') === 0 ? 'abld-name-' : 'abl-m-name-') + sid);
      if (!grid.querySelector('.abl-att-card')) return;
      var sel = grid.querySelector('.abl-att-card.active');
      var key = (nameEl ? nameEl.textContent : '') + '|' + grid.querySelectorAll('.abl-att-card').length + '|' + (sel ? sel.dataset.name : '');
      if (grid.dataset.srEvcKey === key) return;
      grid.dataset.srEvcKey = key;
      mount(grid, nameEl);
    });
  }

  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(scan, 80); }
  function start() {
    addCss(); scan();
    var rz = null; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(placeAll, 150); });
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
